

let allColors = document.querySelectorAll('.colorlist label')
var getData = function () {
    var parent =
        this.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
    var get_selector = parent.getAttribute("data-selector");
    var get_color = this.getAttribute("data-opt-color");
    var handle = parent.getAttribute("data-product-handle");
    var limit = parent.getAttribute("data-id");
    
    let size_selector = document.querySelector(
        '[data-selector="' +
            get_selector +
            '"][data-product-handle="' +
            handle +
            '"][data-id="' +
            limit +
            '"] [data-color-sizes="' +
            get_color +
            '"]'
    );

    var actives = parent.querySelectorAll(".active");
    [].forEach.call(actives, function (elem) {
        elem.classList.remove("active");
    });

    if (size_selector) size_selector.classList.add("active");
    const price_selector = document.querySelector(
        '[data-selector="' +
            get_selector +
            '"][data-product-handle="' +
            handle +
            '"][data-id="' +
            limit +
            '"] [data-color-price="' +
            get_color +
            '"]'
    );
    if (price_selector) price_selector.classList.add("active");
    const title_selector = document.querySelector(
        '[data-selector="' +
            get_selector +
            '"][data-product-handle="' +
            handle +
            '"][data-id="' +
            limit +
            '"] [data-color-title="' +
            get_color +
            '"]'
    );
    if (title_selector) title_selector.classList.add("active");
    const img_selector = document.querySelector(
        '[data-selector="' +
            get_selector +
            '"][data-product-handle="' +
            handle +
            '"][data-id="' +
            limit +
            '"] [data-color-imgs="' +
            get_color +
            '"]'
    );
    if (img_selector) img_selector.classList.add("active");
    const selectedAttr = document.querySelector(
        '[data-selector="' +
            get_selector +
            '"][data-product-handle="' +
            handle +
            '"][data-id="' +
            limit +
            '"] [data-opt-color-selected="1"]'
    );
    if (selectedAttr) selectedAttr.setAttribute("data-opt-color-selected", "0");

    const selectedVariantId =
        (price_selector && price_selector.getAttribute("data_id")) ||
        this.getAttribute("data-opt-id");
    const relatedSelectors = [get_selector];
    if (get_selector.indexOf("pcpsecondary-") === 0) {
        relatedSelectors.push(get_selector.replace("pcpsecondary-", "pcp-"));
    } else if (get_selector.indexOf("pcp-") === 0) {
        relatedSelectors.push(get_selector.replace("pcp-", "pcpsecondary-"));
    }
    relatedSelectors.forEach((selectorName) => {
        const selectorRoot =
            '[data-selector="' +
            selectorName +
            '"][data-product-handle="' +
            handle +
            '"][data-id="' +
            limit +
            '"]';
        const cardLink = document.querySelector(selectorRoot + " a.sizelist-wrap");
        if (cardLink && selectedVariantId) {
            const nextUrl = new URL(cardLink.getAttribute("href"), window.location.origin);
            nextUrl.searchParams.set("variant", selectedVariantId);
            cardLink.setAttribute("href", `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
        }
        const scopedImageLink = document.querySelector(
            selectorRoot + ' [data-color-imgs="' + get_color + '"] .grid-product__image-link'
        );
        if (scopedImageLink && selectedVariantId) {
            const nextImageUrl = new URL(
                scopedImageLink.getAttribute("href"),
                window.location.origin
            );
            nextImageUrl.searchParams.set("variant", selectedVariantId);
            scopedImageLink.setAttribute(
                "href",
                `${nextImageUrl.pathname}${nextImageUrl.search}${nextImageUrl.hash}`
            );
        }
    });

    this.setAttribute("data-opt-color-selected", "1");
};
for (var i = 0; i < allColors.length; i++) {
allColors[i].addEventListener('click', getData, false);
}
